"use client";

import React, {useEffect, useMemo, useReducer, useState} from "react";
import {useSession} from "next-auth/react";
import {
    addProductToCart,
    getCart,
    removeProductFromCart,
    updateCartItem,
    estimateShippingMethods,
    setShippingInformation, setPaymentInformation, sendQuotationRequest, loadQuotationRequest, setCartCouponCode, removeCartCouponCode
} from "provider/magento/api/cart";
import apiFetcher from "provider/magento/apiFetcher";
import {normalizeCart} from "provider/magento/normalizers/cart";
import {normalizePaymentInformation} from "provider/magento/normalizers/payment";
import {getCartToken, setCartToken} from "provider/magento/utilities/cartToken";
import {
    checkOtpRequest,
    checkShippingAddress,
    generateOtpRequest,
    getScalaPayConfirm,
    getScalaPayRedirect
} from "./api/checkout";


const initialState = {


    // store
    store: null,


    // cart

    isLoadingCart: false,
    cart: null,
    quoteToLoad: null,
    quoteIsLoaded: false,
    couponCode: null,


    //
    orderIncrementId: false,
    orderProtectCode: false,

    //wishlist
    wishlist: null,


};

const CommerceContext = React.createContext(null);

CommerceContext.displayName = 'CommerceContext';

function uiReducer(state, action) {
    //console.log(action);
    switch (action.type) {

        case 'SET_STORE': {
            return {
                ...state,
                store: action.payload,
            };
        }

        case 'SET_CART_LOADING': {
            return {
                ...state,
                isLoadingCart: action.payload
            }
        }

        case 'LOAD_CART': {
            return {
                ...state,
                cart: action.payload,
            }
        }

        case 'REMOVE_CART' : {
            return {
                ...state,
                cart: null
            }
        }
        case 'ADD_PRODUCT': {
            return {
                ...state,
                cart: action.payload,
            }

        }
        case 'UPDATE_PRODUCT': {
            return {
                ...state,
                cart: action.payload,
            }
        }
        case 'REMOVE_PRODUCT': {
            return {
                ...state,
                cart: action.payload,
            }
        }


        case 'LOAD_CART_TOTALS': {
            return {
                ...state,
                cart: {
                    ...state.cart,
                    totals: action.payload,
                    totals_info: action.payload
                }
            }
        }


        case 'SET_QUOTE_TO_LOAD': {
            return {
                ...state,
                quoteToLoad: action.payload
            }
        }
        case 'SET_QUOTE_IS_LOADED': {
            return {
                ...state,
                quoteIsLoaded: action.payload
            }
        }

        case 'SET_CART_COUPON': {
            return {
                ...state,
                cart: action.payload,
            }
        }

        case 'SET_ORDER_INCREMENT_ID': {
            return {
                ...state,
                orderIncrementId: action.payload,
            }
        }

        case 'SET_ORDER_PROTECT_CODE': {
            return {
                ...state,
                orderProtectCode: action.payload,
            }
        }


    }
}

export const CommerceProvider = (props) => {

    const [state, dispatch] = useReducer(uiReducer, initialState);

    const [sessionOrCartId, setSessionOrCartId] = useState(null);

    const {data: session, status: sessionStatus} = useSession();
    
    const {storeCode} = props;



    useEffect( () => {

        // check cart

        // session is loading
        async function check() {
            if (sessionStatus === 'loading') return; //console.log('session is loading');

            if (sessionStatus === "unauthenticated") {
                let cartId = getCartToken();
                if (!cartId) {
                   // console.log('CART DOESN\'T EXISTS');
                    setCartIsLoading(false);
                } else {
                    setSessionOrCartId(cartId);
                    //loadCart(cartId);
                }
            } else if (sessionStatus === 'authenticated') {
                setSessionOrCartId(session);
                setCartToken(null);
                //loadCart(session);
            }
        }
        check();


    }, [sessionStatus]);

    useEffect(() => {
        if (sessionOrCartId && !state.isLoadingCart && !state.quoteToLoad && !state.quoteIsLoaded) {
            //console.log('loading cart', sessionOrCartId, state.isLoadingCart, state.quoteToLoad);
            loadCart();
        }

    }, [sessionOrCartId]);

    useEffect(() => {

        if(state.quoteIsLoaded){
            setQuoteIsLoaded(false);
            loadCart();
        }
    }, [state.quoteIsLoaded]);

    useEffect(() => {
        if (((sessionStatus === 'authenticated' && sessionOrCartId) || sessionStatus === 'unauthenticated') && state.quoteToLoad) {
            setQuoteToLoad(null);
            loadQuotation(state.quoteToLoad).then(quote => {

            });
        }
    }, [state.quoteToLoad, sessionStatus, sessionOrCartId]);

/*    useEffect(() => {
        if (storeConfig && storeConfig.store)
            setStore(storeConfig.store)
    }, [storeConfig]);*/


    const setStore = (storeConfig) => {
        dispatch({
            type: 'SET_STORE',
            payload: storeConfig
        })
    }

    const setCartIsLoading = (loading) => {

        dispatch({
            type: 'SET_CART_LOADING',
            payload: loading
        });

    }


    const loadCart = () => {

        //if (state.isLoadingCart) return new Promise((resolve, reject) => reject('cart is already loading'));

        setCartIsLoading(true);

        return apiFetcher(...getCart(sessionOrCartId, storeCode))
            .then((res) => {
                //console.log(res);
                if(res?.fieldName){
                    if(res.fieldName === 'cartId'){
                        //console.log('cartId error', res);
                        if(sessionStatus === 'unauthenticated') {
                            setSessionOrCartId(null);
                        }
                        setCartToken(null);
                        removeCart();
                        return Promise.reject(null);
                    }
                } else {
                    return res;
                }
            }).then(res => {

                if(res && res.parameters && res.parameters.fieldName && res.parameters.fieldName==='cartId'){
                    //console.log(res);
                    if(sessionStatus === 'unauthenticated') {
                        setSessionOrCartId(null);
                    }
                    setCartToken(null);
                    removeCart();
                    return Promise.reject(null);
                }

                if(!res || (Array.isArray(res) && res.length === 0)){
                    if(sessionStatus === 'unauthenticated') {
                        setSessionOrCartId(null);
                    }
                    setCartToken(null);
                    removeCart();
                    return Promise.reject(null);
                }

                return res;
            })
            .then(res => normalizeCart(res))
            .catch(reason => {

                console.log(reason);
                if(reason && reason.parameters && reason.parameters.fieldName && reason.parameters.fieldName==='cartId'){
                    if(sessionStatus === 'unauthenticated') {
                        setSessionOrCartId(null);
                    }
                    setCartToken(null);
                    removeCart();
                }

                dispatch({
                    type: 'LOAD_CART',
                    payload: null
                });

                setCartIsLoading(false);
            }).then(cart => {

                if(cart && !Array.isArray(cart)) {
                    dispatch({
                        type: 'LOAD_CART',
                        payload: cart
                    });
                }

                setCartIsLoading(false);

                return cart;

            });


    }

    const removeItem = (item) => {

        // if (!state.isCartAvailable) return console.log('Cart isn\'t available');

        setCartIsLoading(true);

        return apiFetcher(...removeProductFromCart(sessionOrCartId, item.item_id, storeCode)).catch(reason => setCartIsLoading(false)).then(res => normalizeCart(res)).then((res) => {

            dispatch({
                type: 'REMOVE_PRODUCT',
                payload: res
            });


            setCartIsLoading(false);


            return res;

        });

    }

    const addItem = (sku, qty, customOptions) => {

        //if (state.isLoadingCart) return console.log('Cart is loading');

        //let quoteId = state.cart ? state.cart.id : null;

        setCartIsLoading(true);

        return apiFetcher(...addProductToCart(sessionOrCartId ? sessionOrCartId : 'none', sku, qty, customOptions, storeCode)).then(res => normalizeCart(res)).then((res) => {

            if (!sessionOrCartId && sessionStatus === 'unauthenticated') {

                setSessionOrCartId(res.masked_id);
                setCartToken(res.masked_id);
            }

            dispatch({
                type: 'ADD_PRODUCT',
                payload: res
            });

            //loadCart();
            //setCartUpdated(true);


            //setCartUpdating(false);
            setCartIsLoading(false);


            return res;

        }).catch(reason => {

            setCartIsLoading(false);
            return Promise.reject(reason);
        });

    }

    const updateItem = (itemId, qty = null, customOptions = {}) => {

        //if (!state.isCartAvailable) return console.log('Cart isn\'t available');

        setCartIsLoading(true);

        return apiFetcher(...updateCartItem(sessionOrCartId, itemId, qty, customOptions, storeCode)).catch(reason => setCartIsLoading(false)).then(res => normalizeCart(res)).then((res) => {


            dispatch({
                type: 'UPDATE_PRODUCT',
                payload: res
            });


            setCartIsLoading(false);


            return res;

        });

    }

    const getShippingMethods = (shippingAddress) => {

        //if (!state.isCartAvailable) return console.log('Cart isn\'t available');

        return apiFetcher(...estimateShippingMethods(sessionOrCartId, shippingAddress, storeCode)).then((res) => {

            if (res) {

                /* dispatch({
                     type: 'GET_SHIPPING_METHODS',
                     payload: res
                 });*/

                //loadCart();
                //loadTotals();


            }

            return res;

        });

    }

    const setShippingInfo = (billingAddress, shippingAddress, shippingMethod) => {

        //if (!state.isCartAvailable) return console.log('Cart isn\'t available');
        setCartIsLoading(true);

        return apiFetcher(...setShippingInformation(sessionOrCartId, billingAddress, shippingAddress, shippingMethod.split('/')[0], shippingMethod.split('/')[1], storeCode)).then((res) => {

            if (res) {

                dispatch({
                    type: 'LOAD_CART_TOTALS',
                    payload: res.totals
                });

                setCartIsLoading(false);


                /*                dispatch({
                                    type: 'SET_PAYMENT_METHODS',
                                    payload: res.payment_methods
                                });*/

                //loadCart();
                //loadTotals();


            }

            return res.payment_methods ? res.payment_methods : [];

        });

    }

    const removeCart = () => {
        dispatch({type: 'REMOVE_CART'});
        setCartToken(null);
        if (sessionStatus === 'unauthenticated'){
            setSessionOrCartId(null);
        }
    }

    const buyOrder = (paymentMethod, billingAddress, additionalData) => {

        /*if (!state.isCartAvailable) return console.log('Cart isn\'t available');
        if (!state.checkout.shippingMethod) return console.log('error shipping method');
        if (!state.checkout.paymentMethod) return console.log('error payment method');*/

        // setBuyInProgress(true);


        return apiFetcher(...setPaymentInformation(sessionOrCartId, paymentMethod, billingAddress, additionalData, storeCode)).then(res => normalizePaymentInformation(res)).then(order => {


            if(!order || (!order.increment_id && !['paylater','scalapay','payin4'].includes(paymentMethod))){
                return Promise.reject(order);
            }

            if (sessionStatus === 'unauthenticated' && !['paylater','scalapay','payin4'].includes(paymentMethod)) {
                setSessionOrCartId(null);
                setCartToken(null);
            }
            //setBuyInProgress(false);
            //setEnableBuy(false);

            //loadCart();
            //loadTotals();

            if(!['paylater','scalapay','payin4'].includes(paymentMethod)) {
                removeCart();
            }
            setCartIsLoading(false);


            return order;
        });

    }

    const makeQuotation = (email, beEmail, bePrefix) => {

        return apiFetcher(...sendQuotationRequest(sessionOrCartId,email, storeCode, beEmail, bePrefix)).then(quotation => {

            return quotation;
        });
    }
    const loadQuotation = (incrementId) => {

        //setCartIsLoading(true);
        setCartIsLoading(true);



        return apiFetcher(...loadQuotationRequest(sessionOrCartId, incrementId, storeCode)).then(quote => {

           /* dispatch({
                type: 'LOAD_CART',
                payload: null
            });*/

            if (sessionStatus==='unauthenticated' && quote.masked_id) {
                console.log('unauth ', quote.masked_id);



                setSessionOrCartId(quote.masked_id);
                setCartToken(quote.masked_id);
                //loadCart();
            } else {
                setCartToken(null);
                //loadCart();
            }
            setQuoteIsLoaded(true);
            //setQuoteToLoad(null);

            setCartIsLoading(false);

            return quote;
        });
    }

    const setQuoteToLoad = (incrementId) => {
        dispatch({
            type: 'SET_QUOTE_TO_LOAD',
            payload: incrementId
        });
    }
    const setQuoteIsLoaded = (isLoaded) => {
        dispatch({
            type: 'SET_QUOTE_IS_LOADED',
            payload: isLoaded
        });
    }

    const setCartCoupon = (couponCode) => {

        //if (!state.isCartAvailable) return console.log('Cart isn\'t available');

        setCartIsLoading(true);

        return apiFetcher(...setCartCouponCode(sessionOrCartId, couponCode, storeCode))
            .then((res) => {
                if(res?.message){
                    return Promise.reject(res);
                }
                return res;
            }).then(res => normalizeCart(res)).then((res) => {


            dispatch({
                type: 'SET_CART_COUPON',
                payload: res
            });


            setCartIsLoading(false);


            return res;

        }).catch(reason => setCartIsLoading(false));
    }
    const removeCartCoupon = () => {

        //if (!state.isCartAvailable) return console.log('Cart isn\'t available');

        setCartIsLoading(true);

        return apiFetcher(...removeCartCouponCode(sessionOrCartId, storeCode)).catch(reason => setCartIsLoading(false)).then(res => normalizeCart(res)).then((res) => {


            dispatch({
                type: 'SET_CART_COUPON',
                payload: res
            });


            setCartIsLoading(false);


            return res;

        }).catch(reason => setCartIsLoading(false));
    }

    const getRedirectUrl = () => {
        return apiFetcher(...getScalaPayRedirect(sessionOrCartId, storeCode)).then(res => {
            return res;
        });
    }

    const getScalapayConfirmUrl = (orderToken) => {
        console.log(sessionOrCartId);
        return apiFetcher(...getScalaPayConfirm(sessionOrCartId, orderToken, storeCode)).then(res => {
            return res;
        });
    }

    const setOrderIncrementId = (incrementId) => {


        dispatch({
            type: 'SET_ORDER_INCREMENT_ID',
            payload: incrementId
        });

        if(sessionStatus === 'unauthenticated') {
            setSessionOrCartId(null);
            setCartToken(null);
        }

        removeCart();


    }

    const setOrderProtectCode = (protectCode) => {

        if(sessionStatus === 'unauthenticated') {
            setSessionOrCartId(null);
            setCartToken(null);
        }

        removeCart();

        dispatch({
            type: 'SET_ORDER_PROTECT_CODE',
            payload: protectCode
        });
    }


    const generateOtp = (number) => {
        return apiFetcher(...generateOtpRequest(number, storeCode));
    }

    const checkOtp = (number, otp) => {
        return apiFetcher(...checkOtpRequest(number, otp, storeCode));
    }



    const value = useMemo(
        () => ({
            ...state,
            addItem,
            removeItem,
            updateItem,
            loadCart,
            getShippingMethods,
            setShippingInfo,
            buyOrder,
            makeQuotation,
            loadQuotation,
            setQuoteToLoad,
            setCartCoupon,
            removeCartCoupon,
            getRedirectUrl,
            removeCart,
            setOrderIncrementId,
            setOrderProtectCode,
            setQuoteIsLoaded,
            getScalapayConfirmUrl,
            generateOtp,
            checkOtp
        }),
        [state]
    )

    return <CommerceContext.Provider value={value} {...props} />

}

export const useCommerceContext = () => {
    const context = React.useContext(CommerceContext);
    if (context === undefined) {
        throw new Error(`useCommerceContext must be used within a CommerceProvider`)
    }
    return context
}
